export const wizardMeta = {
  firstRow: {
    title: 'How to import users',
    subItems: [
      {
        title: 'Web System Overview',
        url: 'https://www.youtube.com/embed/YFsS8DcYT9Y',
      },
      {
        title: 'Configuring Groups and Fields',
        url: 'https://www.youtube.com/embed/mSACXe58c3g',
      },
      {
        title: 'Configuring Groups and Fields',
        url: 'https://www.youtube.com/embed/mSACXe58c3g',
      },
    ],
  },
  secondRow: {
    title: 'General Tutorials',
    subItems: [
      {
        title: 'Status Field Types',
        url: 'https://www.youtube.com/embed/PpW2hisNBBY',
      },
      {
        title: 'Adding a New Asset',
        url: 'https://www.youtube.com/embed/_Fvl--zOvcQ',
      },
      {
        title: 'Adding a New Asset',
        url: 'https://www.youtube.com/embed/_Fvl--zOvcQ',
      },
    ],
  },
}

export const navigationSteps = [
  {
    label: 'Beginner Steps',
    size: 4,
    active: ['review_setup'],
    completed: ['create_account'],
    subItems: [
      {title: 'Create your account', enum: 'create_account'},
      {title: 'Review your setup', enum: 'review_setup'},
      {
        title: 'Add your data',
        enum: 'add_data',
        url: `${process.env.REACT_APP_ROOT_API_URL}/asset_items/imports/new`,
      },
      {
        title: 'Invite Your team',
        enum: 'invite_team',
        url: `${process.env.REACT_APP_ROOT_API_URL}/account/users`,
      },
    ],
  },
  {
    label: 'Advance Steps',
    size: 4,
    active: [],
    completed: [],
    subItems: [
      {
        title: 'Configure fields',
        enum: 'configure_fields',
        url: `${process.env.REACT_APP_ROOT_API_URL}/entities`,
      },
      {
        title: 'Setup notifications',
        enum: 'setup_notifications',
        url: `${process.env.REACT_APP_ROOT_API_URL}/account/notifications`,
      },
      {
        title: 'Create reports',
        enum: 'create_reports',
        url: `${process.env.REACT_APP_ROOT_API_URL}/reports`,
      },
      {title: 'Implementation  services', enum: 'customize_workflow'},
    ],
  },
]

export const userProgressArr = [
  'create_account',
  'review_setup',
  'add_data',
  'invite_team',
  'configure_fields',
  'setup_notifications',
  'create_reports',
  'customize_workflow',
]

export const configurationProgressArr = [
  'unexecuted',
  'copy_account',
  'entities',
  'entity_actions',
  'notifications',
  'reports',
]
